import "./index.css";

import { Route, Routes } from "react-router-dom";
import { Suspense, lazy } from "react";

import { MainLayout } from "./layouts/main-layout";
import { Skeleton } from "@/components/ui/skeleton"; // Import Skeleton
import { authClient } from "./lib/auth-client"; // Import authClient
import { useDocumentTitle } from "./hooks/use-document-title";

const AdminUsersPage = lazy(() => import("./pages/admin/users/page"));
const ApiKeyPage = lazy(() => import("./pages/settings/api-keys/page"));
const HomePage = lazy(() => import("./pages/home/page").then(module => ({ default: module.HomePage })));
const LoginPage = lazy(() => import("./pages/login/page").then(module => ({ default: module.LoginPage })));
const NotFoundPage = lazy(() => import("./pages/not-found/page").then(module => ({ default: module.NotFoundPage })));
const ProfileSettingsPage = lazy(() => import("./pages/settings/profile/page"));
const RegisterPage = lazy(() => import("./pages/register/page").then(module => ({ default: module.RegisterPage })));
const AdminActivationProductsPage = lazy(() => import("./pages/admin/activation/products/page"));
const AdminActivationCodesPage = lazy(() => import("./pages/admin/activation/codes/page"));
const AdminOrdersPage = lazy(() => import("./pages/admin/orders/page"));
const UserActivationCodesPage = lazy(() => import("./pages/settings/activation-codes/page"));

function LoadingFallback() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="w-full max-w-md p-8 space-y-4">
        <Skeleton className="h-8 w-3/4" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6" />
        <Skeleton className="h-4 w-1/2" />
      </div>
    </div>
  );
}

export function App() {
  useDocumentTitle();
  const { data: session, isPending } = authClient.useSession(); // Get session state here

  // Show LoadingFallback while session is pending
  if (isPending) {
    return <LoadingFallback />;
  }

  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        {/* Root path without MainLayout */}
        <Route path="/" element={<HomePage />} />

        {/* Routes within MainLayout */}
        <Route element={<MainLayout session={session} isPending={isPending} />}>
          <Route path="/dashboard" element={<div>Dashboard</div>} /> {/* Keep */}
          <Route path="/dashboard/settings/profile" element={<ProfileSettingsPage />} /> {/* Add prefix */}
          <Route path="/dashboard/settings/api-keys" element={<ApiKeyPage />} /> {/* Add prefix */}
          <Route path="/dashboard/admin/users" element={<AdminUsersPage />} /> {/* Add prefix */}
          <Route path="/dashboard/admin/activation/products" element={<AdminActivationProductsPage />} />
          <Route path="/dashboard/admin/activation/codes" element={<AdminActivationCodesPage />} />
          <Route path="/dashboard/admin/orders" element={<AdminOrdersPage />} />
          <Route path="/my-codes" element={<UserActivationCodesPage />} />
        </Route>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}

export default App;
